<template>
  <el-cascader
    size="small"
    :options="options"
    :props="{ expandTrigger: 'hover'}"
    v-model="selectedOptions"
    :style="css"
    @change="handleChange">
  </el-cascader>
</template>

<script>
  import { provinceAndCityData,CodeToText,TextToCode} from 'element-china-area-data'
  import treeToArray from "../TreeTable/eval";
  import {arrayToTree} from "../../views/category/utils";

  export default {
    name: 'CityCascader',
    props:{
      css: {
        type: Object,
        default: () => {
          return {width: '100%'}
        }
      },
      defaultCity:{
        type:String,
        default:()=>{
          return '江苏省/扬州市'
        }
      }
    },
    computed:{
      options:function(){
        return provinceAndCityData
      },
      selectedOptions:{
        get:function(){
          let defaultArr = this.defaultCity.split('/')
          let defalutCode=[TextToCode[defaultArr[0]].code,TextToCode[defaultArr[0]][defaultArr[1]].code]
          return defalutCode;
        },
        set:(value)=>{
          return value
        }
      }
    },
    methods: {
      handleChange (value) {
        this.$emit('cityChosen',CodeToText[value[0]]+'/'+CodeToText[value[1]])
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CityCascader/index.vue